import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
// material
import { IconButton, MenuItem } from '@mui/material';
// component
import Iconify from '../../../components/Iconify';
import MenuPopover from '../../../components/MenuPopover';

// ----------------------------------------------------------------------

export default function CustomerMoreMenu({ item, status, id, onResetPassword }) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const handleCloseMenu = () => {
    setIsOpen(null);
  };

  const handleOpenMenu = (event) => {
    setIsOpen(event.currentTarget);
  };

  return (
    <>
      <MoreMenuButton
        open={isOpen}
        onClose={handleCloseMenu}
        onOpen={handleOpenMenu}
        actions={
          <>
            <MenuItem onClick={onResetPassword}>
              <Iconify icon={'mdi:password-reset'} />
              {t('Reset password')}
            </MenuItem>
          </>
        }
      />
    </>
  );
}

// ----------------------------------------------------------------------

MoreMenuButton.propTypes = {
  actions: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  open: PropTypes.bool,
};

function MoreMenuButton({ actions, open, onOpen, onClose }) {
  const ref = useRef(null);
  return (
    <>
      <IconButton ref={ref} size="large" color="inherit" sx={{ opacity: 0.7 }} onClick={onOpen}>
        <Iconify icon={'eva:more-vertical-fill'} width={20} height={20} />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={ref.current}
        onClose={onClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        arrow="right-top"
        sx={{
          mt: -0.5,
          width: 'auto',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
            '& svg': { mr: 2, width: 20, height: 20 },
          },
        }}
      >
        {actions}
      </MenuPopover>
    </>
  );
}
